<template>
  <!--新增对话框-->
  <el-dialog
    :title="editForm.id ? '编辑轮播图' : '新增轮播图'"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      :model="editForm"
      ref="editForm"
      :rules="editFormRules"
      label-width="100px"
      class="demo-editForm"
    >
      <el-form-item label="标题" prop="title" label-width="130px">
        <el-input v-model="editForm.title" autocomplete="off"> </el-input>
      </el-form-item>
      <el-form-item label="用处" prop="type" label-width="130px">
        <el-radio-group v-model="editForm.type">
          <el-radio :label="1">资讯</el-radio>
          <el-radio :label="2">社区</el-radio>
          <el-radio :label="3">商城</el-radio>
          <el-radio :label="4">我的</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="图片" prop="picUrl" label-width="130px">
        <VploadImg
          :limit="1"
          v-bind:file-list="fileList"
          :type="4"
          :fixed-number="[1, 1]"
          @submitImg="getImgList"
        ></VploadImg>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('editForm')"
          >保存</el-button
        >
        <el-button @click="resetForm('editForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import VploadImg from "../inc/VploadImg";
export default {
  name: "AddUpdateShare",
  components: {
    VploadImg,
  },
  data() {
    return {
      editForm: {},
      fileList: [],
      getCouponsStoreGoodsvisible: false,
      dialogVisible: false,
      editFormRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        picUrl: [{ required: true, message: "请上传图片", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
      },
    };
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.editForm = {};
      this.fileList = [];
    },
    handleClose() {
      this.resetForm("editForm");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        console.log("valid", this.editForm);
        if (valid) {
          this.$axios
            .post(
              "/admin/share/" + (this.editForm.id ? "updateShare" : "addShare"),
              this.editForm
            )
            .then((res) => {
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {
                  this.$emit("refreshDataList");
                },
              });
              this.dialogVisible = false;
              this.resetForm(formName);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getImgList(url, add) {
      if (add == 1) {
        this.editForm.picUrl = url;
      } else if (add == 0) {
        this.editForm.picUrl = "";
      }
    },
    init(id) {
      this.dialogVisible = true;
      if (id != null && id != "" && id > 0) {
        this.$axios
          .post("/admin/share/getShareById", { id: id })
          .then((res) => {
            this.editForm = res.data;
            var filess = { url: res.data.picUrl };
            this.fileList.push(filess);
          });
      }
    },
  },
};
</script>

<style scoped></style>
